<template>
  <div class="card">
    <div class="card-content has-text-centered">
      <div v-show="hasAuth && !documentIsBeingSigned && !documentIsSigned">
        <div class="columns">
          <div class="column"></div>
          <v-dialog />
          <SignatureProviderAuthentication
            class="column is-two-fifths-desktop"
            @updateAuthenticationFormData="authenticationForm = $event"
            @updateAuthenticationFormValidity="isAuthenticationFormValid = $event"
          />
          <div class="column"></div>
        </div>
      </div>
      <div v-show="documentIsBeingSigned">
        <p class="subtitle has-text-centered" v-if="!documentIsBeingSignedWithSic">
          {{ $t('components.signingSteps.documentSigning.download.loadingLabel') }}
        </p>
        <p class="subtitle has-text-centered" v-else>
          {{ $t('components.signingSteps.documentSigning.download.loadingLabelWithSic') }}
        </p>

        <b-progress size="is-large" type="is-tertiary">
        </b-progress>
      </div>
      <div v-show="documentIsSigned">
        <p class="subtitle has-text-centered" v-if="!documentIsBeingDownloaded">
          {{ $t('components.signingSteps.documentSigning.download.readyLabel') }}
        </p>
        <p class="subtitle has-text-centered" v-else>
          {{ $t('components.signingSteps.documentSigning.download.downloadingLabel') }}
        </p>

        <b-progress size="is-large" type="is-tertiary" v-if="documentIsBeingDownloaded">
        </b-progress>
      </div>
    </div>

    <footer
      class="card-footer"
      v-if="!hasAuth || isAuthenticationFormValid"
    >
      <a
        v-show="!documentIsBeingSigned && !documentIsSigned"
        @click="togglePdfPrv"
        class="card-footer-item"
      >
        {{ $t('components.signingSteps.documentSigning.buttonShowPdf') }}

        <b-icon icon="arrow-down" v-if="!this.$store.getters.getshowPdfPrv">
        </b-icon>
        <b-icon icon="arrow-up" v-if="this.$store.getters.getshowPdfPrv">
        </b-icon>
      </a>
      <a
        v-show="!documentIsBeingSigned && !documentIsSigned"
        @click="sign(file)"
        class="card-footer-item"
      >
        {{ $t('components.signingSteps.documentSigning.buttonLabel') }}

        <b-icon icon="draw">
        </b-icon>
      </a>
      <a
        v-show="documentIsSigned && !documentIsBeingDownloaded"
        @click="downloadDocument"
        class="card-footer-item"
      >
        {{ $t('components.signingSteps.documentSigning.download.downloadButtonLabel') }}

        <b-icon icon="download">
        </b-icon>
      </a>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import SignatureProviderAuthentication from '@/components/stepper/subcomponents/SignatureProviderAuthentication.vue'

export default {
  name: 'DocumentSigning',
  components: {
    SignatureProviderAuthentication
  },
  data () {
    return {
      authenticationForm: {
        email: '',
        phone: '',
        username: '',
        password: '',
        otpCode: ''
      },
      isAuthenticationFormValid: false,
      documentIsBeingSigned: false,
      documentIsBeingDownloaded: false,
      documentIsSigned: false,
      pollingFunction: null
    }
  },
  computed: {
    hasAuth () {
      return this.getSelectedSignatureProviderHasEmailAuth() ||
             this.getSelectedSignatureProviderHasPhoneAuth() ||
             this.getSelectedSignatureProviderHasUsernameAuth()
    }
  },
  methods: {
    ...mapActions([
      'loadUploadedDocumentInfo',
      'loadDocument',
      'signDocument'
    ]),
    ...mapGetters([
      'getUploadedDocumentInfo',
      'getSelectedSignatureProvider',
      'getSelectedSignatureProviderHasEmailAuth',
      'getSelectedSignatureProviderHasPhoneAuth',
      'getSelectedSignatureProviderHasUsernameAuth'
    ]),
    togglePdfPrv () {
      // console.log(this.$store.getters.getshowPdfPrv)
      this.$store.commit('setshowPdfPrv', !this.$store.getters.getshowPdfPrv)
      // console.log(this.$store.getters.getshowPdfPrv)
      if (this.$store.getters.getshowPdfPrv) {
        localStorage.setItem('hasVisualSig', true)
      }
    },
    downloadDocument () {
      let payload = {}
      payload.id = this.getUploadedDocumentInfo().id
      payload.signed = true

      this.documentIsBeingDownloaded = true

      this.loadDocument(payload)
        .then(response => {
          this.documentIsBeingDownloaded = false

          let downloadUrl = window.URL.createObjectURL(new Blob([response.data]))
          let link = document.createElement('a')

          link.href = downloadUrl
          let filename = decodeURIComponent(response.headers['content-disposition'].split('filename*=UTF-8\'\'')[1].replace(/^"(.+(?="$))"$/, '$1'))
          link.setAttribute('download', filename)

          document.body.appendChild(link)

          link.click()

          this.$emit('documentDownloaded')
        })
        .catch(error => {
          // TODO: Temporary workaround for babel-transform-remove-console
          //       plugin not working.
          // eslint-disable-next-line
          console.error('GET /api/documents/' + uploadedDocumentId + '/download failed with error: ' + error.message)

          this.documentIsBeingDownloaded = false

          this.$buefy.toast.open({
            duration: 5500,
            message: this.$t('components.signingSteps.documentSigning.documentDownloadFailedToast'),
            position: 'is-bottom',
            type: 'is-danger'
          })
        })
    },
    pollUploadedDocumentInfo () {
      this.pollingFunction = setInterval(() => {
        let uploadedDocumentId = this.getUploadedDocumentInfo().id

        if (!uploadedDocumentId) return

        this.loadUploadedDocumentInfo(uploadedDocumentId)
          .then(response => {
            this.documentIsSigned = response.data.signed

            if (this.documentIsSigned && this.pollingFunction) {
              clearInterval(this.pollingFunction)

              this.documentIsBeingSigned = false
              this.pollingFunction = false
            }
          })
          .catch(error => {
            // TODO: Temporary workaround for babel-transform-remove-console
            //       plugin not working.
            // eslint-disable-next-line
            console.error('GET /api/documents/' + uploadedDocumentId + ' failed with error: ' + error.message)
          })
      }, 3000)
    },
    sign (file) {
      let signatureProvider = this.getSelectedSignatureProvider()

      // hide pdf preview when sign is clicked
      this.$store.commit('setshowPdfPrv', false)

      if (signatureProvider.hasOwnProperty('id')) {
        let formData = new FormData()

        formData.append('id', this.getUploadedDocumentInfo().id)
        formData.append('signatureProviderId', signatureProvider.id)
        formData.append('email', this.authenticationForm.email)
        formData.append('phone', this.authenticationForm.phone)
        formData.append('username', this.authenticationForm.username)
        formData.append('password', this.authenticationForm.password)
        formData.append('otpCode', this.authenticationForm.otpCode)

        let hasVisualSig = localStorage.getItem('hasVisualSig')
        let hasVisualSigPlacement = localStorage.getItem('hasVisualSigPlacement')
        let visualSigPage = localStorage.getItem('visualSigPage')
        let xCoord = localStorage.getItem('xCoord')
        let yCoord = localStorage.getItem('yCoord')
        let bottomBoundCoord = localStorage.getItem('bottomBoundCoord')
        let leftBoundCoord = localStorage.getItem('leftBoundCoord')
        let rightBoundCoord = localStorage.getItem('rightBoundCoord')
        let topBoundCoord = localStorage.getItem('topBoundCoord')
        let xCoordPercentage = null
        let yCoordPercentage = null

        if (hasVisualSig && hasVisualSigPlacement && xCoord != null && yCoord != null && bottomBoundCoord != null && leftBoundCoord != null && rightBoundCoord != null && topBoundCoord != null) {
          xCoordPercentage = (xCoord - leftBoundCoord) / (rightBoundCoord - leftBoundCoord)
          yCoordPercentage = (yCoord - topBoundCoord) / (bottomBoundCoord - topBoundCoord)

          if (xCoordPercentage != null && yCoordPercentage != null) {
            formData.append('hasVisualSig', hasVisualSig)
            formData.append('hasVisualSigPlacement', hasVisualSigPlacement)
            formData.append('visualSigPage', visualSigPage)
            formData.append('xCoordPercentage', xCoordPercentage)
            formData.append('yCoordPercentage', yCoordPercentage)
          }
        }

        this.documentIsBeingSigned = true
        if (signatureProvider.id === 5) {
          this.documentIsBeingSignedWithSic = true
        }

        /* console.log('===> sign()')
        for (var pair of formData.entries()) {
          console.log(pair[0] + ', ' + pair[1])
        }
        console.log('hasVisualSig: ' + hasVisualSig)
        console.log('hasVisualSigPlacement: ' + hasVisualSigPlacement)
        console.log('visualSigPage: ' + visualSigPage)
        console.log('xCoord: ' + xCoord)
        console.log('yCoord: ' + yCoord)
        console.log('bottomBoundCoord: ' + bottomBoundCoord)
        console.log('leftBoundCoord: ' + leftBoundCoord)
        console.log('rightBoundCoord: ' + rightBoundCoord)
        console.log('topBoundCoord: ' + topBoundCoord)
        console.log('xCoordPercentage: ' + xCoordPercentage)
        console.log('yCoordPercentage: ' + yCoordPercentage)
        console.log('<===========================') */

        this.signDocument(formData)
          .then(response => {
            this.pollUploadedDocumentInfo()
          })
          .catch(error => {
            // console.error('POST /api/documents/sign failed with error: ', error.message)

            this.documentIsBeingSigned = false

            let errorDescription = error.response.data.errorDescription
            if (typeof errorDescription === 'undefined' && signatureProvider.id === 5 && error.response.status === 504) {
              errorDescription = 'timeoutWithSic'
            }

            this.$buefy.toast.open({
              duration: 7500,
              message: this.$t('components.signingSteps.documentSigning.documentSigningFailedToast') + this.$t('components.signingSteps.documentSigning.' + errorDescription),
              position: 'is-bottom',
              type: 'is-danger'
            })
          })
      }
    }
  },
  beforeDestroy () {
    if (this.pollingFunction) {
      clearInterval(this.pollingFunction)

      this.pollingFunction = false
    }
  }
}
</script>
